<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" width="70%" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine">
                            <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                                <el-collapse-transition>
                                    <div class="h-thirdColumn w-newColumn" v-if="showStatus">
                                        <el-form-item label="采购订单号" style="width: 33%;">
                                            <el-input v-model="formInline.cgId" placeholder="多订单模糊查询请用空格或分号分隔" />
                                        </el-form-item>
                                        <el-form-item label="对账状态" style="width: 33%;">
                                            <el-input v-model="formInline.billStatus" disabled />
                                        </el-form-item>
                                      <el-form-item style="width: 33%;">
                                        <el-checkbox v-model="formInline.isFk" v-if="showStatus">是否只显示未付款节点</el-checkbox>
                                      </el-form-item>
<!--                                        <div class="l-screenBox">-->
<!--                                            <el-checkbox v-model="formInline.isFk" v-if="showStatus">是否只显示未付款节点</el-checkbox>-->
<!--                                            <div class="l-retrieval">-->
<!--                                                <el-button class="h-btn h-formBtn" v-if="showStatus" @click="jiansuo">检索</el-button>-->
<!--                                                <el-button class="h-btn h-formBtn h-bgwhite" v-if="showStatus" @click="chongzhil">重置</el-button>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                    </div>
                                </el-collapse-transition>
                            </el-form>
                        </div>
                        <div class="h-formbLine" v-if="showStatus">
                            <el-form :inline="true" :model="commitData" class="demo-form-inline h-formBorder">
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="收款银行账号" required style="width: 33%;">
                                        <el-select clearable v-model="commitData.accountHolderName" placeholder="请选择">
                                            <el-option
                                                v-for="item in bankList"
                                                :key="item.accountHolderName"
                                                :label="item.accountHolderName"
                                                :value="item.accountHolderName">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="开户行名称" required style="width: 33%;">
                                        <el-input v-model="commitData.bankName" disabled />
                                    </el-form-item>
                                    <el-form-item label="开户行编码" required style="width: 33%;">
                                        <el-input v-model="commitData.bankBranchCode" disabled />
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn" v-if="cgType === '2'">
                                    <el-form-item label="云超市合同号" style="width: 33%;">
                                        <el-select
                                            v-model="commitData.contractCode"
                                            multiple
                                            filterable
                                            allow-create
                                            default-first-option
                                            placeholder="请选择云超市合同">
                                            <el-option
                                                v-for="item in contractList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="合同名称" style="width: 33%;">
                                        <el-input v-model="commitData.contractName" />
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn" v-if="cgType === '2'">
                                    <el-form-item label="合同开始时间" style="width: 33%;">
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="commitData.contractStartDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="合同结束时间" style="width: 33%;">
                                        <el-date-picker
                                            placeholder="请选择"
                                            v-model="commitData.contractEndDate"
                                            clearable
                                            type="date"
                                            value-format="yyyy-MM-dd" >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                                <div class="h-thirdColumn w-newColumn">
                                    <el-form-item label="付款摘要" style="width: 33%;">
                                        <el-input v-model="commitData.paySummary"/>
                                    </el-form-item>
                                    <el-form-item label="发票状态" style="width: 33%;" required>
                                        <el-select v-model="commitData.invoiceOption" placeholder="请选择">
                                            <el-option
                                                v-for="item in invoiceOptionList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                        <el-table
                                ref="multipleTable"
                                @selection-change="handleSelectionChangeFK"
                                :data="tableData"
                                :span-method="objectSpanMethod"
                                style="width: 100%"
                                :border="true"
                                :cell-style="cellStyle"
                        >
                            <el-table-column :selectable="checkSelect" type="selection" width="45"></el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="采购订单号"
                                    width="130"
                                    :show-overflow-tooltip="true"
                                    fixed>
                            </el-table-column>
                            <el-table-column
                                    prop="paymentNode"
                                    label="付款节点"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template slot-scope="scope">
                                    <dictname category="payment_node"  :v="scope.row.paymentNode"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="isPayment"
                                    label="付款状态"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                <template slot-scope="scope">
                                    <dictname category="cg_fkstatus"  :v="scope.row.isPayment"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="fukuanbili"
                                    label="付款比例(%)"
                                    width="130">
                            </el-table-column>
                            <el-table-column
                                    prop="payAmount"
                                    label="付款金额(元)"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="付款币种"
                                    :show-overflow-tooltip="true"
                                    width="142">
                                <template slot-scope="scope">
                                    <dictname category="YLCurrency"  :v="scope.row.currency"/>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="paymentDate"
                                    label="付款时间"
                                    :show-overflow-tooltip="true"
                            >
                            </el-table-column>
                            <div v-if="cgType === '1'">">
                                <el-table-column
                                    prop="contractCode"
                                    label="云超市合同号"
                                    width="140">
                                </el-table-column>
                                <el-table-column
                                    prop="contractName"
                                    label="合同名称"
                                    width="140">
                                </el-table-column>
                                <el-table-column
                                    prop="startDate"
                                    label="合同开始日期"
                                    width="140">
                                </el-table-column>
                                <el-table-column
                                    prop="endDate"
                                    label="合同结束日期"
                                    width="140">
                                </el-table-column>
                            </div>
                        </el-table>
                        <div class="h-tableB ">
                            <div class="h-tableBL" style="margin-top: 15px" v-if="showStatus">
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('1')" >首付款全选</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('2')" >发货款全选</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('3')" >到货款全选</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('4')" >验收款全选</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('5')" >质保金全选</el-button>
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="toggleSelection('6')" >付全款全选</el-button>
                            </div>
                            <div class="xuanding" v-if="yxamount > 0" style="font-size: 16px;text-align: right;margin-top: 15px;">
                                付款小计：
                                <span class="allmoney">
                                  <span style="font-weight: 600;">{{yxamount.toFixed(2)}}</span>元
                                </span>
                            </div>
                        </div>
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h4 style="margin: 8px 0;">扣款:</h4>
<!--                                <div class="h-tableAdd" v-if="showStatus" @click="adds">-->
<!--                                  <a>新增一行</a>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="N-chan">
                            <div class="yxtable ljjtable">
                                <el-table
                                        ref="ddtable"
                                        :data="tableData3"
                                        style="width: 100%"
                                        border
                                >
                                    <el-table-column type="index" width="40" label="#"></el-table-column>
                                    <el-table-column prop="deductionReason" label="扣款原因">
                                        <template slot-scope="scope">
                                            <el-input type="text" placeholder="请输入"
                                                      v-model="scope.row.deductionReason" maxlength="50" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="deductionPrice"
                                            label="扣款金额"
                                            width="180">
                                        <template slot-scope="scope">
                                            <el-input oninput="value=value.replace(/[^\d.]/g,'').replace(/(\..*)\./g,'$1').replace(/^\./g,'0.').replace(/\.(\d{2})\d*/g,'.$1').replace(/^0+(?=\d)/g,'')"
                                                      placeholder="请输入" v-model="scope.row.deductionPrice"
                                                      maxlength="10" @change="changeNum(scope.row)" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            label="操作"
                                            width="120"
                                            fixed="right"
                                    >
                                        <template slot-scope="scope">
                                          <el-button type="text" v-if="showStatus" size="small" class="h-tableLink h-btn"
                                                     @click="delPlan(scope.$index,scope.row)">删除
                                          </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="h-tableAdd" v-if="showStatus" @click="adds">
                                    <a>新增一行</a>
                                </div>
                            </div>
                            <el-form ref="form"
                                     :inline="true" class="demo-ruleForm h-formbLine new-dialogForm">
                            <!-- 附件上传 -->
                                <el-form-item prop="fileUrl" label="扣款单" class="h-elformWrap-2" >
                                    <brupload
                                            v-model="fileUrl"
                                            :refid=kouKuanid
                                            reftype="CG_KK"
                                            :limit="1"
                                            :showtime="false"
                                            uploadflag
                                            delflag>
                                    </brupload>
                                </el-form-item>
                              <el-form-item class="h-elformWrap-2 totalCount">
                                <div class="xuanding" style="font-size: 16px;text-align: right;">
                                  扣款小计：
                                  <span class="allmoney"><span style="font-weight: 600;">{{kkamount}}</span>元
                              </span>
                                </div>
                                <div class="xuanding" style="font-size: 16px;text-align: right;">
                                  本次付款总计：
                                  <span class="allmoney"><span style="font-weight: 600;">{{totalAmount}}</span>元
                                </span>
                                </div>
                              </el-form-item>
                            </el-form>

                            <el-form ref="form" v-if="showImage"
                                     :inline="true" class="demo-ruleForm h-formbLine new-dialogForm">
                                <!-- 附件上传 -->
                                <el-form-item prop="imageAttachment" label="影像附件" class="h-elformWrap-2" >
                                    <brupload
                                        v-model="imageAttachment"
                                        :refid=imageAttachmentId
                                        reftype="imageAttachment"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag>
                                    </brupload>
                                </el-form-item>
                            </el-form>

                        </div>
                        <div class="h-txtCenter h-mrt30" v-if="showStatus">
                            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitFk">确认提交</el-button>
                        </div>
                        <div class="h-txtCenter h-mrt30" v-if="showImage">
                            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitImage">影像重提</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import big from 'big.js'
    export default {
        name: "createApply",
        data() {
            return{
                formInline:{
                    isPayment:null,
                    cgId: '',
                    isFk:false,
                    invoiceId:'',
                    billStatus:"",
                },
                commitData:{
                    paymentPrice:null,
                    deductPrice:null,
                    finalPrice:null,
                    kkFjId:null,
                    accountHolderName: '',
                    bankName: '',
                    bankBranchCode: '',
                    contractCode: '',
                    contractName: '',
                    contractEndDate: '',
                    contractStartDate: '',
                    paySummary: '',
                    invoiceOption: null,
                },
                tableData:[],
                //游标集
                spanArr:[],
                yxamount: 0,
                kkamount:0,
                totalAmount:0,
                tableData3:[],
                fileUrl:[],
                imageAttachment:'',
                imageAttachmentId: '',
                kouKuanid:'',
                showStatus: true,
                showImage: false,
                cgType: '',
                bankList: [],
                contractList: [],
                invoiceOptionList: [
                    {
                        value: '1',
                        label: '发票先到'
                    },
                    {
                        value: '2',
                        label: '发票后到'
                    }
                ],
            }
        },
        methods:{
            handleSelectionChangeFK(val) {
                var amount = 0;
                this.multipleSelection = val;
                this.multipleSelection.forEach((item, index) => {
                    amount = (amount*100 + item.payAmount*100)/100;
                })
                this.yxamount = amount;
                this.totalAmount = (new big((this.yxamount*100 - this.kkamount*100)/100)).toFixed(2);
            },
            //查询方法
            jiansuo() {
                this.query();
            },
            //查询付款信息
            query() {
                if(this.CgCodeList){
                    this.formInline.cgIds = this.CgCodeList;
                }
                if(this.CgCode){
                    this.formInline.invoiceId = this.CgCode;
                }
                var data  = null;
                data = this.formInline;
                ss.invoiceApplyList.selectFkList(data).then(rd => {
                    this.tableData = rd.msg;
                    // 遍历tableData，获取cgType。若存在不同值则提示：服务采购单、普通采购单不能混合付款，一致则赋值给cgType
                    for(var i = 0; i < this.tableData.length; i++){
                        if(i === 0){
                            this.cgType = this.tableData[i].cgType;
                        }else{
                            if(this.tableData[i].cgType !== this.cgType){
                                this.$message.error('服务采购单、普通采购单不能混合付款');
                                this.$emit('choseObj');
                                return;
                            }
                        }
                    }
                    if (this.cgType === '2') {
                        this.commitData.invoiceOption = '1';
                    }
                    this.getSpanArr();
                })
            },
            //重置方法
            chongzhil() {
                this.tableData = []
            },
            //合并单元行方法
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                if (columnIndex == 1) {

                    //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
                    const _row = this.spanArr[rowIndex];

                    //该行跨了几列
                    const _col = _row > 0 ? 1 : 0;

                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },

            //记录游标的方法
            getSpanArr() {

                //游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
                this.spanArr = [];

                //遍历当前表元素
                this.tableData.forEach((item, index) => {

                    //当第一行时
                    if (index === 0) {

                        //默认先放第一行是1次
                        this.spanArr.push(1);

                        //记录当前重复行的位置
                        this.position = 0;

                        //其他行
                    } else {

                        //如果该行上的pcid与上一行上的pcid重复
                        if (this.tableData[index].code === this.tableData[index - 1].code) {

                            //从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
                            this.spanArr[this.position] += 1;

                            //因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
                            this.spanArr.push(0);

                            //若不重复
                        } else {

                            //继续向游标集放入一个1作为本行没有重复的独立一次记录
                            this.spanArr.push(1);

                            //记录重复行位置的游标移动到本行位置
                            this.position = index;

                        }
                    }
                })

            },
            closeDialog(){
                this.tableData = []
            },
            toggleSelection(index) {
                var rows = [];
                rows = this.tableData;
                if (rows) {
                    rows.forEach(row => {
                        if(row.paymentNode == index && row.isPayment != 2 && row.isPayment != 1){
                            this.$refs.multipleTable.toggleRowSelection(row);
                        }
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            //增加行
            adds() {
                var list = {
                    deductionReason: '',
                    deductionPrice: '',
                }
                this.tableData3.push(list)
            },
            //删除框
            delPlan(index, q) {
                this.$confirm('确认删除？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
                    .then(_ => {

                        //如果原来有数据
/*                        if (q.id != null) {//把要删除的主键id存起来
                            this.yaoshanchude.push({id: q.id});
                        }*/
                        this.tableData3.splice(index, 1)
                        console.log("删除一行数据",this.tableData3);
                        if(this.tableData3){
                            var kk = 0;
                            for(var i = 0;i<this.tableData3.length;i++){
                                var kkData = this.tableData3[i];
                                kk = new big(kkData.deductionPrice).plus(kk);
                            }
                            this.kkamount = kk;
                            this.totalAmount = (new big((this.yxamount*100 - this.kkamount*100)/100)).toFixed(2);
                        }else {
                            this.totalAmount = (new big((this.yxamount*100 + this.kkamount*100)/100)).toFixed(2);
                            this.kkamount = 0;
                        }
                    })
                    .catch(_ => {
                    });
            },
            //创建初始绑定附件的id,提价后后台改为付款单号
            createKkId(){
                ss.invoiceApplyList.createKoukuanFjId().then(rd => {
                    this.kouKuanid = rd.msg;
                })
            },
            createdImageAttachmentId() {
                // CGFK + 当前时间 (YYYYMMDD) + 6 位随机字符 (字母 + 数字)
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                const randomStr = Math.random().toString(36).substr(2, 6).toUpperCase();
                this.imageAttachmentId = 'CGFK' + year + month + day + randomStr;
            },
            //扣款汇总
            changeNum(v) {
                var total=0;
                for(var i=0;i<this.tableData3.length;i++){
                    var data = this.tableData3[i];
                    if(data.deductionPrice){
                        total=new big(data.deductionPrice).plus(total);
                    }
                }
                this.kkamount = total;
                this.totalAmount = (new big((this.yxamount*100 - this.kkamount*100)/100)).toFixed(2);
            },
            //提交付款
            commitFk() {
                // 参数校验：银行信息
                if (!this.commitData.accountHolderName) {
                    this.$message.error('请选择收款银行账号');
                    return;
                }
                if (!this.commitData.invoiceOption) {
                    this.$message.error('请选择发票选项');
                    return;
                }
                // 检查cgType为1时，是否有contractCode为空的订单，并收集未维护合同号的采购订单号
                if (this.cgType === '1') {
                    const emptyContractOrders = this.tableData
                        .filter(item => !item.contractCode)
                        .map(item => item.code);
                    // 去重
                    const uniqueEmptyContractOrders = [...new Set(emptyContractOrders)];
                    if (uniqueEmptyContractOrders.length > 0) {
                        const orderList = uniqueEmptyContractOrders.join('、');
                        this.$message.error(`${orderList}未维护云超市合同号`);
                        return;
                    }
                }
                // 参数校验：2为服务订单，合同信息不能为空
                if (this.cgType === '2') {
                    const missingFields = [];
                    if (!this.commitData.contractCode) {
                        missingFields.push('云超市合同号');

                    } else {
                        this.commitData.contractCode = Array.isArray(this.commitData.contractCode) ?
                            this.commitData.contractCode.join(',') : this.commitData.contractCode;
                    }
                    if (!this.commitData.contractName) missingFields.push('合同名称');
                    if (!this.commitData.contractStartDate) missingFields.push('合同开始时间');
                    if (!this.commitData.contractEndDate) missingFields.push('合同结束时间');
                    console.log("contractEndDate", this.commitData.contractEndDate);
                    console.log("contractStartDate", this.commitData.contractStartDate);

                    if (missingFields.length > 0) {
                        this.$message.error(`请完善以下合同信息：${missingFields.join('、')}`);
                        return;
                    }
                }

                // 封装参数
                this.commitData.paymentPrice = new big(this.yxamount);
                this.commitData.deductPrice = new big(this.kkamount);
                this.commitData.finalPrice = new big(this.totalAmount);
                this.commitData.detailList = this.multipleSelection;
                this.commitData.kkFjId = this.kouKuanid;
                this.commitData.imageAttachmentId = this.imageAttachmentId;
                this.commitData.deductionList = this.tableData3;
                // 提交请求
                ss.invoiceApplyList.paymentAndApproval(this.commitData).then(rd => {
                    if (rd.f) {
                        this.$message.success('提交成功');
                        this.$emit('choseObj', this.commitData);
                    } else {
                        this.$message.error(rd.msg);
                    }
                });
            },
            fukuanDetailSelct(){
                var id = this.FukuanId;
                ss.invoiceApplyList.getFukuanDataById(id).then(rd => {
                    this.tableData = rd.msg.detailList;
                    this.tableData3 = rd.msg.deductionList;



                    this.yxamount = rd.msg.paymentPrice;
                    this.kkamount = rd.msg.deductPrice;
                    this.totalAmount = rd.msg.finalPrice;
                    this.kouKuanid = rd.msg.paymentCode;
                    this.getSpanArr();
                });
            },
            //表格颜色
            cellStyle({ row, column, rowIndex, columnIndex }) {
                if (rowIndex % 2 == 1 && row.isPayment != 2) {
                    return 'background:rgba(0,150,200,0.1)'
                }
                if (rowIndex % 2 == 0 && row.isPayment != 2) {
                    return 'background:rgba(227,0,0,0.1)'
                }
                if (row.isPayment == 2) {
                    return 'background:rgba(100,188,0,0.1)'
                }
            },
            //判断是否可以输入
            inputCheck() {
                if(this.showStatus){
                    return false
                }else{
                    return  true
                }
            },
            //判断数据是否可被选中
            checkSelect(row,index) {
                let isChecked = true;
                if (row.isPayment === 2 || row.isPayment === 1) { // 判断里面是否存在某个参数
                    isChecked = false
                } else {
                    isChecked = true
                }
                return isChecked
            },
            getBillStatus(){
                var data = {
                    supplierCode: this.supplierCode,
                    purchaseOrderCode: this.gscode,
                }
                ss.invoiceApplyList.selectIssueBill(data).then(rd => {
                    this.formInline.billStatus = rd.msg;
                })
            },
            getBankList(){
                ss.invoiceApplyList.getSupplierBank(this.SupplierCode).then(rd => {
                    this.bankList = rd.obj;
                    if (rd.obj == null || rd.obj.length === 0 ) {
                        this.$msg.msg("供应商无银行信息，请维护银行信息")
                    } else {
                        // 找到 createTime 或 updateTime 最新的那条记录
                        const latestBank = this.findLatestBank(rd.obj);
                        if (latestBank) {
                            this.commitData.accountHolderName = latestBank.accountHolderName;
                        }
                    }
                })
            },
            findLatestBank(bankList) {
                if (!bankList || bankList.length === 0) return null;

                // 将数组按时间排序，返回最新的那条
                return bankList.reduce((latest, current) => {
                    const latestTime = new Date(latest.updateTime || latest.createTime || 0);
                    const currentTime = new Date(current.updateTime || current.createTime || 0);
                    return currentTime > latestTime ? current : latest;
                });
            },
            commitImage() {
                const params = {
                    paymentId:this.FukuanId,
                    imageAttachmentId:this.imageAttachmentId,
                }
                ss.invoiceApplyList.secondarySubmission(params).then(rd => {
                    if (rd.f) {
                        this.$message.success('提交成功');
                        this.$emit('closeFK');
                    } else {
                        this.$message.error(rd.msg);
                    }
                });

            }
        },
        created(){
            if(this.CgCodeList || this.cgCode){
                this.query()
                this.getBankList();
            }
            this.createKkId();
            if(this.FukuanId){
                this.fukuanDetailSelct();
                this.showStatus = false;
            }
            this.createdImageAttachmentId();
            console.log(this.fkStatus + 'fkStatus')
            if (this.fkStatus === '8') {
                this.showImage = true;
            }
            this.getBillStatus();
        },
        mounted() {
            // this.init();
            // this.loadlist();
        },
        computed: {
            CgCodeList:function() {
                return this.cgCodeList;
            },
            FukuanId:function () {
                return this.fukuanId;
            },
            CgCode:function () {
                return this.cgCode;
            },
            SupplierCode:function () {
                return this.supplierCode;
            },
            Gscode:function () {
                return this.gscode;
            }
        },
        props: {
            cgCodeList: {
                type: String,
            },
            fukuanId: {
                type: String,
            },
            fkStatus: {
                type: String,
            },
            cgCode: {
                type: String,
            },
            supplierCode: {
                type: String,
            },
            gscode: {
                type: String,
            }
        },
        watch: {
            'commitData.accountHolderName'(newVal) {
                if (newVal) {
                    // 从 bankList 中查找匹配的银行信息
                    const selectedBank = this.bankList.find(
                        (item) => item.accountHolderName === newVal
                    );

                    if (selectedBank) {
                        // 赋值到 commitData 的其他字段
                        this.commitData.bankName = selectedBank.bankName || '';
                        this.commitData.bankBranchCode = selectedBank.bankBranchCode || '';
                    } else {
                        // 未找到匹配项时清空字段
                        this.commitData.bankName = '';
                        this.commitData.bankBranchCode = '';
                    }
                } else {
                    // accountHolderName 为空时清空字段
                    this.commitData.bankName = '';
                    this.commitData.bankBranchCode = '';
                }
            }
        }
    }
</script>
<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 0 20px 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
    .xuanzewuliao .allmoney{
        color: #DC143C;
        /*font-size: 0.30rem;*/
        /*padding-right: 0.2rem;*/
    }
    .xuanzewuliao .fubiaoti{
        color: #0e76e9;
        font-size: 0.50rem;
        padding-right: 0.2rem;
    }
    .xuanzewuliao .h-tableAdd {
        height: 0.46rem;
        line-height: 0.46rem;
        background-color: #59b2fc;
        width: 14%;
        text-align: center;
    }
    .xuanzewuliao .h-elformWrap-2 {
        width: 50%;
    }
</style>
<style scoped>
.new-dialogForm{
  margin-top: 15px;
}
::v-deep .h-formbLine .h-elformWrap-2{
  margin-bottom: 0;
}
::v-deep .xuanzewuliao .new-dialogForm .el-form-item__label{
  width: 20%!important;
}
::v-deep .h-formbLine .totalCount{
  padding-right: 0;
  text-align: right;
}
::v-deep .xuanzewuliao .h-formbLine .el-form-item__label{
  font-size: 0.18rem;
}
::v-deep .el-checkbox__label{
  font-size: 0.18rem;
}
</style>
